import SubPatch from './SubPatch.js';
import ObjectRegistered from './ObjectRegistered.js';
import {uuid} from 'uuidv4';

export default class InstancedSubPatch extends ObjectRegistered(SubPatch) {
    
    constructor(subSequence, sequencerEngine, zObject) {
        super(subSequence, sequencerEngine, zObject, "Instanced");

        this.instanceObjectMapping = {};
    }


    fromJson(json, isCopy=false, isInstance) {
        if (isCopy) {
            this.id = uuid();
        } else {
            this.id = json.id;
        }
        this.sequencerEngine.idToObject[this.id] = this;
        return {};
    }

    getJson() {
        return {
            id: this.id,
        };
    }

    dispose() {
        if (this.implements) {
            this.implements.instances = this.implements.instances.filter(
                x => x !== this);
        }
    }

    isDeletable() {
        return true;
    }
}
